import {Permissions} from 'auth/PermissionConstants';
import {makeReactContext} from 'lib/makeReactContext';
import {GenericResponseJSON} from 'notifications';
import {OngoingTaskResponse} from 'util/TaskRunner';

import {ReviewableQuery_reviewable as Reviewable} from './__generated/ReviewableQuery';
import {Review, ReviewAction} from './ReviewConstants';

export enum ReviewErrorType {
  TOOLTIP = 'tooltip',
  COMPONENT = 'component',
  CALLBACK = 'callback',
}

export type ReviewError =
  | {
      type: ReviewErrorType.TOOLTIP;
      error: (reviewableId: string) => string | null;
    }
  | {
      type: ReviewErrorType.COMPONENT;
      error: JSX.Element | null;
    }
  | {
      type: ReviewErrorType.CALLBACK;
      error?: (error: {responseJSON?: GenericResponseJSON}) => JSX.Element | null;
    };

export interface ReviewBadgeContextValue {
  isDropdownOpen: boolean;
  setIsDropdownOpen: (isOpen: boolean) => void;
  reviewError?: ReviewError;
  onReviewChange?: (
    reviewableId: string,
    review: Review,
    filePermissions: Permissions,
    snapshotTask: OngoingTaskResponse | null
  ) => void;
  performanceMetadata?: {[key: string]: string}; // takes in performance metric
  reviewable?: Reviewable;
  reviewableId?: string;
  /** Custom rendering of additional info related to the review stage in modal */
  renderAdditionalReviewInfo?: (reviewableId: string, reviewAction: ReviewAction) => JSX.Element | null;
  openHistory?: () => void;
  reviewId?: string;
}

export function getReviewBadgeContextFallback(): ReviewBadgeContextValue {
  return {
    isDropdownOpen: false,
    setIsDropdownOpen: (isOpen) => {},
  };
}

// Controls the open/close state of the review badge
export const ReviewBadgeContext = makeReactContext<ReviewBadgeContextValue>(
  getReviewBadgeContextFallback,
  'ReviewBadgeContext'
);
